export default __webpack_public_path__ + "static/complian-c4a98e7b49ea5b17ef5fd9ddd7e8eb2c.jpg";